module.exports = __webpack_public_path__ + "static/media/RKBrowser1w1100@1x.941a8af7.jpg";